import {
  Component,
  ElementRef,
  ViewChild,
  Inject,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { MyListingsService } from '../../services/my-listings.service';
import { LoginService } from '../../services/login.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { ToastService, ToastType } from '../../services/toast.service';
import { UserService } from '../../services/user.service';
import { AppState } from 'src/app/app.state';
import { UserState } from 'src/state/user.state';
import { CookieStorageService } from 'src/app/services/cookie-storage.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],
})

export class SignInComponent {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private route: ActivatedRoute,
    public appState: AppState,
    public loginService: LoginService,
    public localStorageService: LocalStorageService,
    public toastService: ToastService,
    public userService: UserService,
    private cookieStorageService: CookieStorageService,
    public myListingsService: MyListingsService,
    private cdr: ChangeDetectorRef,
    public userState: UserState
  ) { }

  hide = true;
  form: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });
  submitted = false;
  isLoader = false;
  isLoginFailed = false;
  historyState: any;

  companyInfo: any;
  websiteUrl: string;

  @ViewChild('input2') input2: ElementRef;

  ngOnInit(): void {
    this.historyState = history.state;
    this.route.queryParams.subscribe((params) => {
      let code = params['code'] ? params['code'] : null;

      if (code) {
        this.router.navigate([], {
          queryParams: {},
          replaceUrl: true,
          state: { skipUpdate: true },
        });

        let appleSignInParams = { type: 'SignInWithApple', code: code };

        this.loginService.socialMediaLogin(appleSignInParams).subscribe({
          next: (res) => {
            if (res && res.data && res.data.refreshToken && res.data.idToken) {

              this.cookieStorageService.setCookie('accessToken', res.data.accessToken);
              this.cookieStorageService.setCookie('refreshToken', res.data.refreshToken);
              this.cookieStorageService.setCookie('idToken', res.data.idToken);

              this.router.navigateByUrl('/search');

              this.cdr.detectChanges();

              this.reloadPage();
            }
          },
          error: (err) => {
            if (err && err.message) {
              this.toastService.toast(
                'Session expired please login again!!!!',
                ToastType.Error
              );
            }
          },
        });
      }
    });

    this.appState.companyInfo$.subscribe((res) => {
      if (res) {
        this.companyInfo = res;
        this.websiteUrl = this.companyInfo.sellSideConfig?.websiteUrl;
      }
    });
  }

  signUp(): void {
    this.router.navigateByUrl('/signup', {
      state: this.historyState,
    });
  }

  forgotPassword(): void {
    window.open(
      'https://' + this.appState.companyInfoValue?.baseUrl + '/forgotPassword',
      '_self'
    );
  }

  logInWithIDP(idp) {
    let redirectionUrl = `${this.appState?.companyInfoValue?.awsCognitoConfig.userPoolDomainUrl}/oauth2/authorize?client_id=${this.appState?.companyInfoValue?.awsCognitoConfig.clientId}&redirect_uri=${this.appState?.companyInfoValue?.awsCognitoConfig.redirectUrl}&response_type=code&identity_provider=${idp}`;
    if (idp == 'SignInWithGoogle') {
      this.document.location.href = redirectionUrl;
    } else {
      this.document.location.href = redirectionUrl;
    }
  }

  onSubmit(): void {
    this.submitted = true;
    this.isLoginFailed = false;

    if (this.form.status == 'VALID') {
      this.isLoader = true;
      let loginInput = {
        userName: this.form.value.email.toLowerCase(),
        password: this.form.value.password,
      };
      this.loginService.UserLogin(loginInput).subscribe({
        next: (res) => {
          if (
            res &&
            res.refreshToken
          ) {
            this.cookieStorageService.setCookie('accessToken', res.accessToken);
            this.cookieStorageService.setCookie('refreshToken', res.refreshToken);
            this.cookieStorageService.setCookie('idToken', res.idToken);

            this.getUserInfo(loginInput.userName);
          } else {
            this.isLoader = false;
            this.isLoginFailed = true;
            console.log('Login Fails!!!!');
          }
        },
        error: (err) => {
          this.isLoader = false;
          this.isLoginFailed = true;
          console.log(err);
        },
      });
    }
  }

  getUserInfo(userName) {
    let input = {
      where: {
        email: encodeURIComponent(userName),
      },
    };
    this.userService.GetUsers(input).subscribe({
      next: (res) => {
        if (res && res.length > 0) {
          let user = res[0];
          user['userFullName'] = user.firstName + ' ' + user.lastName;
          user['userName'] = userName;
          this.userState.getUserDetails = user;

          if (
            this.historyState &&
            this.historyState.address &&
            this.historyState.address != null
          ) {
            this.router.navigateByUrl('/home-details', {
              state: this.historyState,
            });
            this.isLoader = false;
          } else if (this.localStorageService.get('addressInfo')) {
            this.router.navigateByUrl('/search');
            this.isLoader = false;
          } else {
            this.loadSavedSearches(user.id);
          }
        } else {
          this.isLoader = false;
          this.toastService.toast('Get User Data Fails!!!!', ToastType.Error);
          console.log('GetUsers Fails!!!! :', res);
        }
      },
      error: (err) => {
        this.isLoader = false;
        this.toastService.toast(
          'Error while getting User data!!!',
          ToastType.Error
        );
        console.log('GetUsers err : ', err);
      },
    });
  }

  loadSavedSearches(userId) {
    let input = {
      where: {
        userId: userId,
      },
      order: 'id DESC',
    };

    this.myListingsService.GetListings(input).subscribe({
      next: (res) => {
        if (res && res.length > 0) {
          this.router.navigateByUrl('/my-listing');
          this.cdr.detectChanges();
          // this.reloadPage();
        } else {
          this.router.navigateByUrl('');
          console.log('GetListings Fails!!!!');
        }
        this.isLoader = false;
      },
      error: (err) => {
        this.router.navigateByUrl('');
        this.isLoader = false;
        console.log('GetListings err : ', err);
      },
    });
  }

  reloadPage() {
    window.location.reload();
  }

  changepasswordIcon() {
    this.hide = !this.hide;
  }

  // to navigate to next field when user click on the email field
  transferFocus(event: KeyboardEvent) {
    event.preventDefault();
    this.input2.nativeElement.focus();
  }
}
